(function () {
  // 置換したい文字列のペア（左：元の文言／右：変更後）
  var replacements = [
    ["サブスクリプション", "定期購入"],
    ["いつでも自動更新、スキップ、キャンセルできます。", "いつでも商品変更・スキップ・キャンセルできます。"],
    ["いつでも自動更新、スキップ、キャンセルできます", "いつでも商品変更・スキップ・キャンセルできます"]
  ];

  function replaceTextInNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      var text = node.nodeValue;
      var changed = false;
      replacements.forEach(function (pair) {
        if (text.indexOf(pair[0]) !== -1) {
          text = text.split(pair[0]).join(pair[1]);
          changed = true;
        }
      });
      if (changed) {
        node.nodeValue = text;
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      // input, textarea, script, style は除外
      var tag = node.tagName;
      if (tag === "SCRIPT" || tag === "STYLE" || tag === "INPUT" || tag === "TEXTAREA") {
        return;
      }
      node.childNodes.forEach(function (child) {
        replaceTextInNode(child);
      });
    }
  }

  function runReplace() {
    replaceTextInNode(document.body);
  }

  // 初回実行
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runReplace);
  } else {
    runReplace();
  }

  // アプリがJSで後からDOMを書き換えるケースに対応するため監視する
  var observer = new MutationObserver(function () {
    runReplace();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();